import script from "./AppLauncher.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLauncher.vue?vue&type=script&setup=true&lang=js"

import "./AppLauncher.vue?vue&type=style&index=0&id=da487254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da487254"]])

export default __exports__